"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getProjectTheme = function getProjectTheme(theme) {
  var size = function size() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var s1 = args[0],
      s2 = args[1],
      s3 = args[2],
      s4 = args[3];
    var result = [s1, s2, s3, s4].reduce(function (acc, s) {
      if (typeof s === 'number' && Number.isFinite(s)) {
        return [].concat(_toConsumableArray(acc), ["".concat(s * theme.size.unit, "px")]);
      }
      return acc;
    }, []);
    return result.join(' ');
  };
  var color = function color(c1, c2, p) {
    var result = [];
    [c1, c2].forEach(function (c) {
      if (c) {
        result.push(c);
      }
    });
    if (result.length === 0) {
      return '';
    }
    if (result.length === 1) {
      return result[0];
    }
    var power = 50;
    if (typeof p === 'number' && p >= 0 && p <= 1) {
      power = p * 100;
    }
    var r1 = result[0],
      r2 = result[1];
    return "color-mix(in srgb, ".concat(r1, " ").concat(power, "%, ").concat(r2, ")");
  };
  var scroll = function scroll(opts) {
    var w = (opts === null || opts === void 0 ? void 0 : opts.size) || 6;
    var c = (opts === null || opts === void 0 ? void 0 : opts.color) || 'primary';
    return {
      '&::-webkit-scrollbar': {
        width: "".concat(w, "px"),
        height: "".concat(w, "px"),
        backgroundColor: color(theme.palette.accent[c].color, theme.palette.accent[c].contrast.low)
      },
      '&::-webkit-scrollbar-thumb': {
        transitionDuration: '200ms',
        backgroundColor: color(theme.palette.accent[c].color, theme.palette.accent[c].contrast.high, 0.75),
        borderRadius: "".concat(w / 2, "px"),
        border: "1px solid ".concat(color(theme.palette.accent[c].color, theme.palette.accent[c].contrast.low)),
        '&:hover': {
          backgroundColor: color(theme.palette.accent[c].color, theme.palette.accent[c].contrast.high, 0.25)
        }
      }
    };
  };
  var text = function text(opts) {
    var variant = (opts === null || opts === void 0 ? void 0 : opts.variant) || 'main';
    var size = (opts === null || opts === void 0 ? void 0 : opts.size) || 'medium';
    var weight = (opts === null || opts === void 0 ? void 0 : opts.weight) || 'normal';
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, theme.typography.main.base), theme.typography.main.size[size]), theme.typography.main.weight[weight]), theme.typography[variant].base), theme.typography[variant].size[size]), theme.typography[variant].weight[weight]);
  };
  return _objectSpread(_objectSpread({}, theme), {}, {
    size: size,
    color: color,
    scroll: scroll,
    text: text,
    screen: {
      down: function down(v) {
        return "@media (max-width: ".concat(theme.breakpoints[v], "px)");
      },
      up: function up(v) {
        var screenRange = ['mobile', 'tablet', 'desktop'];
        var targetIndex = screenRange.indexOf(v);
        var t = screenRange[targetIndex + 1];
        var screen = theme.breakpoints[t] || 0;
        return "@media (min-width: ".concat(screen, "px)");
      }
    }
  });
};
var _default = getProjectTheme;
exports["default"] = _default;